<template>




                                <div class="hotel--wrapper" :key="keyS">
                                    <b-spinner v-if="loading"></b-spinner>
                                    <b-row>
                                        <b-col cols="11" offset="1">
                                            <div class="service--overnight--hotels">
                                                <div class="hotel">
                                                    <b-row>
                                                        <b-col cols="12" md="2" v-if="!struttura_id" >
                                                            <b-form-group label="Carica da Expedia" label-for="eps_property_id" class="add-hotel">
                                                                <div class="service--item--add d-flex">
                                                                    <b-form-input
                                                                        class="add-hotel--input"
                                                                        size="sm"
                                                                        id="eps_property_id"
                                                                        v-model="eps_property_id"
                                                                        placeholder="Expedia Hotel ID"
                                                                    ></b-form-input>
                                                                    <b-badge class="add-hotel--badge" @click="get_eps_property_from_api" :variant="eps_property_id == '' ? 'light' : 'primary'">carica</b-badge>
                                                                </div>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col cols="12" md="3">
                                                            <b-form-group id="property_name" label="Hotel (*)" label-for="property_name">
                                                                <b-form-input
                                                                    size="sm"
                                                                    id="property_name"
                                                                    v-model="property_name"
                                                                    placeholder="Nome della struttura"
                                                                    @input="updated"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col cols="12" md="9" v-if="struttura_id">
                                                            <b-form-group id="geoposition" label="Geocode" label-for="geoposition">
                                                                <autocomplete
                                                                    :search="geoSearch"
                                                                    size="sm"
                                                                    placeholder="Geocode"
                                                                    aria-label="Geocode"
                                                                    :get-result-value="getResultValue"
                                                                    @submit="handleSubmit"
                                                                    :debounceTime="1000"
                                                                ></autocomplete>
                                                            </b-form-group>                        
                                                        </b-col>
                                                        <b-col cols="12" md="7" v-else>
                                                            <b-form-group id="geoposition" label="Geocode" label-for="geoposition">
                                                                <autocomplete
                                                                    :search="geoSearch"
                                                                    size="sm"
                                                                    placeholder="Geocode"
                                                                    aria-label="Geocode"
                                                                    :get-result-value="getResultValue"
                                                                    @submit="handleSubmit"
                                                                    :debounceTime="1000"
                                                                ></autocomplete>
                                                            </b-form-group>                        
                                                        </b-col>
                                                        <b-col cols="12" md="2">
                                                            <b-form-group id="address" label="Indirizzo (*)" label-for="address">
                                                                <b-form-input
                                                                    size="sm"
                                                                    id="address"
                                                                    v-model="address"
                                                                    placeholder="Indirizzo"
                                                                    @input="updated"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col cols="12" md="2">
                                                            <b-form-group id="city" label="Città (*)" label-for="city">
                                                                <b-form-input
                                                                    size="sm"
                                                                    id="city"
                                                                    v-model="city"
                                                                    :disabled = true
                                                                    placeholder="Città"
                                                                    @input="updated"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col cols="12" md="2">
                                                            <b-form-group id="country_code" label="Country code" label-for="country_code">
                                                                <b-form-input
                                                                    size="sm"
                                                                    id="country_code"
                                                                    v-model="country_code"
                                                                    :disabled = true
                                                                    placeholder="Country code"
                                                                    @input="updated"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col cols="12" md="3">
                                                            <b-form-group id="latitude" label="Latitudine(*)" label-for="latitude">
                                                                <b-form-input
                                                                    size="sm"
                                                                    id="latitude"
                                                                    v-model="latitude"
                                                                    :disabled = true
                                                                    placeholder="Latitudine"
                                                                    @input="updated"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col cols="12" md="3">
                                                            <b-form-group id="longitude" label="Longitudine (*)" label-for="longitude">
                                                                <b-form-input
                                                                    size="sm"
                                                                    id="longitude"
                                                                    :disabled = true
                                                                    v-model="longitude"
                                                                    placeholder="Longitudine"
                                                                    @input="updated"
                                                                ></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col cols="12" md="6">
                                                            <b-form-group id="property_info">
                                                                <tiny-mce
                                                                    :preview_mode="true"
                                                                    :height="400"
                                                                    :block_title="'Informazioni struttura'"
                                                                    :initial_value="this.property_info"
                                                                    @input="updatePropertyInfo"
                                                                />
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col cols="12" md="6">
                                                            <b-form-group id="property_important_info">
                                                                <tiny-mce
                                                                    :preview_mode="true"
                                                                    :height="400"
                                                                    :block_title="'Informazioni importanti'"
                                                                    :initial_value="this.property_important_info"
                                                                    @input="updatePropertyImportantInfo"
                                                                />
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col cols="12" md="4">
                                                            <b-form-group id="coverUrl" label="Copertina" label-for="coverUrl">
                                                                <b-row>
                                                                    <b-col cols="12" md="10">
                                                                        <img v-if="this.gallery && this.gallery[this.coverIndex]" v-bind:src="this.gallery[this.coverIndex].image" style="width: 100%; margin: 10px;">
                                                                    </b-col>
                                                                </b-row>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col cols="12" md="10">
                                                            <b-form-group label="Gallery" id="gallery" label-for="gallery">
                                                                <b-row v-if="!struttura_id && isExpedia">
                                                                    <b-col cols="12" md="2" v-for="(gallery_item, index ) in this.gallery" v-bind:key="'immagine_'+ index" >
                                                                        <img v-bind:src="gallery_item" style="width: 100%; margin: 10px;">
                                                                    </b-col>
                                                                </b-row>
                                                                <b-row  v-if="struttura_id">
                                                                    <b-col cols="12" md="2" v-for="(gallery_item, index ) in this.gallery" v-bind:key="'immagine_'+ index" >
                                                                        <b-button title="rimuovi immagine" class="btn-danger btn-sm" @click="removeImmagineStruttura(index)">X</b-button>
                                                                            <b-form-checkbox
                                                                            :id="'setCover_' + index"
                                                                            v-model="coverIndex"
                                                                            :value=index
                                                                            unchecked-value=false
                                                                            ></b-form-checkbox>
                                                                        <img v-bind:src="gallery_item.image" style="width: 100%; margin: 10px;">
                                                                    </b-col>
                                                                </b-row>                                                                                                                      
                                                            </b-form-group>
                                                        </b-col>

                                                        <b-col ref="drag" :class="{over: isOver}" cols="12" md="10" v-if="!isExpedia || struttura_id" class="imageArea" v-cloak @drop.prevent="addFile" @dragover.prevent>
                                                                <b-row>
                                                                    <b-col cols="12" md="10"  >
                                                                        <h4>Trascina qui le immagini che vuoi caricare...</h4>
                                                                        <sub>è consentito il formato 'landscape' e una risoluzione minima di 800px</sub>
                                                                        <b-row >
                                                                            <b-col cols="12" md="2" v-for="(file, index) in this.files" v-bind:key="'immagine_'+ index">
                                                                                <b-button title="rimuovi immagine" class="btn-danger btn-sm" @click="removeFile(file)">X</b-button>
                                                                                <img v-bind:src="file.thumb" style="width: 100%; margin: 10px;"><br>
                                                                                
                                                                            </b-col>
                                                                        </b-row>                                                                                                                           
                                                                    </b-col>
                                                                </b-row>
                                                        </b-col>

                                                        <b-col cols="12" md="5" v-if="!struttura_id">
                                                            <!--<b-button class="btn-secondary btn-sm right-10" title="carica immagini" v-b-modal="'immagini_'+_uid">aggiungi immagini</b-button>-->
                                                            <b-button title="salva struttura" class="btn-success btn-sm" @click="save_struttura_to_boa">Salva struttura</b-button>
                                                        </b-col>

                                                        <b-col cols="12" md="5" v-else>
                                                            <!--<b-button class="btn-secondary btn-sm right-10" title="carica immagini" v-b-modal="'immagini_'+_uid">aggiungi immagini</b-button>-->
                                                            <b-button title="aggiorna struttura" class="btn-success btn-sm" @click="update_struttura_to_boa">Aggiorna struttura</b-button>
                                                        </b-col>
                                                            
                                                            
                                                    </b-row>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                        
                    <!--</b-modal>-->
                

</template>

<script>
    import Vue from 'vue'
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'
    import TinyMce from '@/components/blocks/tiny-mce'

    import { get_eps_property, get_struttura, post_struttura, put_struttura, get_reverse_geocoding} from '@/api'

    export default {
        name: 'structures',
        components: {
            'tiny-mce': TinyMce,
            'Autocomplete': Autocomplete
        },
        props: ['struttura_id', 'structName'],
        created() {
            this.post_struttura = post_struttura,
            this.get_struttura = get_struttura
        },
        data() {
            return {
                files: [],
                newImages: [],
                cheveretoTrash: [],
                keyS: 0,
                coverIndex: 0,
                isExpedia: false,
                isOver: false,
                banconiste: Vue.prototype.$config.banconiste,
                loading: true,
                eps_property_id: this.eps_property_id,
                property_name: (this.structName != '' ? this.structName : this.property_name),
                address: this.address,
                city: this.city,
                country_code: this.country_code,
                coordinates: this.coordinates,
                latitude: this.latitude,
                longitude: this.longitude,
                coverUrl: this.coverUrl,
                gallery: (typeof this.gallery === 'undefined' ? [] : this.gallery),
                property_info: this.property_info,
                property_important_info: this.property_important_info,
            }
        },
        mounted() {
            this.loading = false;
            if(this.struttura_id){  //stessa modale ma con assegnata id struttura per il recupero, 

                this.get_struttura_from_boa()

            }
        },
        methods:
        {
            closeMe(){
                this.$emit('closeModalStructures')
            }, 

            save_struttura_to_boa()
            {

                if(!this.property_name || !this.address || !this.city || !this.latitude || !this.longitude) {
                    Vue.$toast.error('uno o più campi obbligatori mancanti')
                    return
                }

                let payload = {
                        isExpedia: this.isExpedia,                    
                        name: this.property_name,
                        address: this.address,
                        city: this.city,
                        country_code: this.country_code,
                        coordinates: {
                            lat: this.latitude,
                            lng: this.longitude,
                        },
                        property_info: this.property_info,
                        property_important_info: this.property_important_info,
                        eps_property_id: this.eps_property_id ? this.eps_property_id : 0,
                        /*coverUrl: this.coverUrl,*/
                        cover: this.coverIndex,
                        gallery: this.gallery,
                        noResult: false
                }
                Vue.$toast.info('salvataggio struttura e immagini in corso...')
                this.loading = true
                post_struttura(payload)
                .then((response)=>{
                    (response)
                        if(response.data.status == 'exists'){
                            Vue.$toast.error('struttura ' + this.eps_property_id + ' già inserita')
                        } else if(response.data.status == 'success') {
                            Vue.$toast.success('salvataggio struttura ' + this.property_name + ' completato')
                            if(response.data.gallery.hasOwnProperty('db')){
                                if(response.data.gallery.db){
                                    Vue.$toast.success('Immagini su DB - OK')
                                } else {
                                    Vue.$toast.error('Immagini su DB - KO')
                                }
                            }
                            if(response.data.gallery.hasOwnProperty('chevereto_add')){
                                if(response.data.gallery.chevereto_add){
                                    Vue.$toast.success('Chevereto Upload - OK')
                                } else {
                                    Vue.$toast.error('Chevereto Upload - KO')
                                }
                            }
                            if(response.data.gallery.hasOwnProperty('chevereto_del')){
                                if(response.data.gallery.chevereto_del){
                                    Vue.$toast.success('Chevereto Delete - OK')
                                } else {
                                    Vue.$toast.error('Chevereto Delete - KO')
                                }
                            }

                            this.$emit('setNewStrutturaToQuote', response.data.struttura)

                            this.closeMe()
                        }
                        
                })
            },

            update_struttura_to_boa()
            {

                if(!this.property_name || !this.address || !this.city || !this.latitude || !this.longitude) {
                    Vue.$toast.error('uno o più campi obbligatori mancanti')
                    return
                }

                let payload = {
                        id: this.struttura_id,
                        name: this.property_name,
                        address: this.address,
                        city: this.city,
                        country_code: this.country_code,
                        coordinates: {
                            lat: this.latitude,
                            lng: this.longitude,
                        },
                        property_info: this.property_info,
                        property_important_info: this.property_important_info,
                        /*coverUrl: this.coverUrl,*/
                        gallery: this.gallery,
                        cover: this.coverIndex,
                        newImages: this.newImages,
                        cheveretoTrash: this.cheveretoTrash,
                }
                Vue.$toast.info('aggiornamento struttura in corso...')
                this.loading = true
                put_struttura(payload)
                .then((response)=>{
                    (response)
                        Vue.$toast.success('aggiornamento struttura ' + this.property_name + ' completato')
                            if(response.data.gallery.hasOwnProperty('db')){
                                if(response.data.gallery.db){
                                    Vue.$toast.success('Immagini su DB - OK')
                                } else {
                                    Vue.$toast.error('Immagini su DB - KO')
                                }
                            }
                            if(response.data.gallery.hasOwnProperty('chevereto_add')){
                                if(response.data.gallery.chevereto_add){
                                    Vue.$toast.success('Chevereto Upload - OK')
                                } else {
                                    Vue.$toast.error('Chevereto Upload - KO')
                                }
                            }
                            if(response.data.gallery.hasOwnProperty('chevereto_del')){
                                if(response.data.gallery.chevereto_del){
                                    Vue.$toast.success('Chevereto Delete - OK')
                                } else {
                                    Vue.$toast.error('Chevereto Delete - KO')
                                }
                            }
                        this.closeMe()
                })
            },

            updated()
            {
                let payload = {
                    hotel_index: this.hotel_index,
                    hotel: {
                        ...this.hotel,
                        property_name: this.property_name,
                        address: this.address,
                        city: this.city,
                        country_code: this.country_code,
                        checkin: this.checkin,
                        checkout: this.checkout,
                        rooms: this.rooms,
                        coordinates: this.coordinates,
                        latitude: this.latitude,
                        longitude: this.longitude,
                        coverUrl: this.coverUrl,
                        gallery: this.gallery,
                        property_info: this.property_info,
                        property_important_info: this.property_important_info,
                    }
                }
                this.$emit('updated', payload)
            },

            get_eps_property_from_api()
            {
                if(this.eps_property_id == ''){
                  Vue.$toast.error('invalid hotel id')
                  this.isExpedia = false
                  return
                }

                Vue.$toast.info('cerco hotel expedia ' + this.eps_property_id)

                get_eps_property({
                    eps_property_id: this.eps_property_id,
                })
                    .then(
                        
                        (success) => {

                            Vue.$toast.success('trovato: ' + success.data.overnight_hotel.property_name)
                            this.isExpedia = true
                            this.address = success.data.overnight_hotel.address
                            this.coordinates = success.data.overnight_hotel.coordinates
                            this.latitude = success.data.overnight_hotel.coordinates.latitude
                            this.longitude = success.data.overnight_hotel.coordinates.longitude
                            this.city = success.data.overnight_hotel.city
                            this.country_code = success.data.overnight_hotel.country_code
                            this.coverUrl = success.data.overnight_hotel.coverUrl
                            this.gallery = success.data.overnight_hotel.gallery
                            this.property_name = success.data.overnight_hotel.property_name
                            this.property_info = success.data.overnight_hotel.property_info,
                            this.property_important_info = success.data.overnight_hotel.property_important_info,
                            this.keyS++
                            this.updated()
                        },

                        (error) => {(error)}

                    )
            },

            get_struttura_from_boa()
            {

                Vue.$toast.info('cerco struttura ' + this.struttura_id)

                get_struttura({
                    id: this.struttura_id,
                    'autocompSubmitForQuote': 0
                })
                    .then(
                        
                        (success) => {

                            Vue.$toast.success('trovato: ' + success.struttura.name)

                            if(success.struttura.eps_property_id && success.struttura.eps_property_id != 0) this.isExpedia = true
                            this.address = success.struttura.address
                            this.coordinates = JSON.parse(success.struttura.coordinates)
                            this.latitude = this.coordinates.lat
                            this.longitude = this.coordinates.lng
                            this.city = success.struttura.city
                            this.country_code = success.struttura.country_code
                            this.property_name = success.struttura.name
                            this.property_info = success.struttura.property_info
                            this.property_important_info = success.struttura.property_important_info
                            this.coverIndex = success.struttura.cover
                            this.gallery = JSON.parse(success.struttura.gallery)
                            this.keyS++

                        },

                        (error) => {(error)}

                    )
            },

            geoSearch(input) {
            this.value = input

            return new Promise(resolve => {
                if (input.length < 3) {
                return resolve([])
                }

                let payload = {
                        q: this.value,
                }

                get_reverse_geocoding(payload).then(
                    (data) => {
                        if (this.value) {
                        resolve(data)
                        } else {
                        resolve([])
                        }
                    }
                )


            })
            },

            getResultValue(result) {
                return result.address.label
            },

            handleSubmit(result) {
                this.latitude = result.position.lat
                this.longitude = result.position.lng
                this.address = result.address.street + (result.address.houseNumber ? ', '+result.address.houseNumber : '')
                this.city = result.address.city
                this.country_code = result.countryInfo.alpha2     
            },
            
            clear() {
            this.value = ''
            this.$refs.autocomplete.value = ''
            },
            addFile(e) {
            let droppedFiles = e.dataTransfer.files;
            let rawImg;
            
            if(!droppedFiles) return;

            ([...droppedFiles]).forEach(f => {


                f.blob = ''
                let binaryData = [];
                let validImage = true;
                let ratio = 'ok';
                let larghezza = 'ok';
                binaryData.push(f)
                let URL = (window.URL || window.webkitURL)
                if (URL) {
                    
                f.blob = URL.createObjectURL(new Blob(binaryData, {type: f.type}))
                    var img = new Image();
                    img.src = f.blob;

                    img.onload = () => {
                        if((parseInt(img.width)/parseInt(img.height)) <= 1){
                            validImage = false
                            ratio = 'ko';
                        }

                        if(parseInt(img.width) < 800){
                            validImage = false
                            larghezza = 'ko'
                        }

                        if(validImage){
                            var reader = new FileReader()

                            reader.onloadend = () => {
                            rawImg = reader.result;

                            if(!this.struttura_id) { 
                                this.gallery.push(rawImg);
                            } else {
                                this.newImages.push(rawImg);
                            }
                            }
                            reader.readAsDataURL(new Blob(binaryData, {type: f.type}));

                            f.thumb = ''
                            if (f.blob && f.type.substr(0, 6) === 'image/') {
                            f.thumb = f.blob
                            }

                            this.files.push(f);

                        }else{
                            Vue.$toast.error('il file ' + f.name + ' non è valido <br> ' + 'larghezza (' + larghezza + ') - landscape ('+ ratio +')')
                        }

                    };

                }

            });
            
            },
            removeFile(file){
            this.files = this.files.filter(f => {
                return f != file;
            });
                if(!this.struttura_id){
                this.gallery = this.gallery.filter(f => {
                    return f != file.thumb;
                });        
                } else {
                this.newImages = this.newImages.filter(f => {
                    return f != file.thumb;
                });        
                }
            },

            removeImmagineStruttura(index){

                if(!confirm('Confermi l\'eliminazione dell\'immagine? (ID '+index+')')) return

                let isCheveretoImage = this.gallery[index].image.includes("vacanze.vivamod");

                if(isCheveretoImage) this.cheveretoTrash.push(this.gallery[index]); // what to push unto the rows array?

                this.gallery.splice(index, 1);
            
            },

            updatePropertyInfo: function(newContent) {
                this.property_info = newContent
            },

            updatePropertyImportantInfo: function(newContent) {
                this.property_important_info = newContent
            },

        }
    }
</script>

<style lang="scss">
.imageArea{
    border:solid 1px #000; border-style:dotted; margin:15px; padding: 15px;
}
.over{
    border:solid 3px #000; border-style:dotted; margin:15px; padding: 15px;
}
    .hotel
    {
        #property_info.form-group,
        #property_important_info.form-group
        {
            margin-bottom:0;
        }
        &--datetime--label
        {
            width:100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        &--room
        {
            display: flex;
            align-items: center;
        }
        .add-hotel
        {
            &--input
            {
                border-top-right-radius:0;
                border-bottom-right-radius:0;
                padding-right:28px;
                color:$primary;
                &::placeholder
                {
                    //color:$primary;
                }
            }
            &--badge
            {
                margin-left:-20px;
                color:$white;
                &.badge-light
                {
                    cursor: initial;
                    color:rgba($black,0.5);
                }
            }
        }

        &--room--panel
        {
            @include subpanel;
            background:rgba($gray-100,1);
        }
    }
    .right-10{
        margin-right:10px
    }
</style>